const KininaruView = App.Views.Base.extend({
  el: '.js-kininaru',
  events: {
    'click .js-kininaru-toggle': 'handleToggle'
  },
  props: {
    box: null,
    frame: null,
    url: 'https://docs.google.com/forms/d/1rCR5Zq7sNIfJ7W1GUqTV3wqAPao38TLvdtYQsS_mgmk/viewform?embedded=true'
  },
  initialize: function() {
    // 初期化
    this.props.frame = $('.js-kininaru-iframe', this.$el)
    this.props.box = $('.js-kininaru-iframe-box', this.$el)
  },
  handleToggle: function() {
    const src = this.props.box.is(':visible') ? null : this.props.url
    this.props.frame.attr('src', src)
    this.props.box.toggle('fast')
  }
})

module.exports = KininaruView



// WEBPACK FOOTER //
// ./view/kininaru.js